import { create } from "zustand";

type SelectionState = {
  selected: Set<number>;
  toggle: (cardId: number) => void;
  setMany: (ids: Iterable<number>) => void;
  clear: () => void;
  isSelected: (cardId: number) => boolean;
};

export const useSelection = create<SelectionState>((set, get) => ({
  selected: new Set<number>(),
  toggle: (cardId) =>
    set((s) => {
      const next = new Set(s.selected);
      if (next.has(cardId)) next.delete(cardId);
      else next.add(cardId);
      return { selected: next };
    }),
  setMany: (ids) => set({ selected: new Set(ids) }),
  clear: () => set({ selected: new Set() }),
  isSelected: (cardId) => get().selected.has(cardId),
}));
